<template>
  <div>
    <b-card no-body>
      <b-tabs small card justified v-model="scanTabIndex">
        <!--  {{deviceID}} {{scans}} -->
        <b-tab v-for="(scan, name, idx) in scans" :key="idx" :title='setName(name)' lazy>
          <b-row no-gutters>
            <b-col sm=12>
              <div v-if="scan.survey && scan.survey.length > 0">
                <b-table small hover :fields="scanfields" :items="scan.survey" responsive="sm" primary-key="bssid" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                  <template #cell(index)="data">{{ data.index + 1 }}</template>
                  <template #table-caption>An empty SSID field indicates that the SSID is hidden</template>
                </b-table>
              </div>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {

  },
  props: {
    deviceID: '',
    scans: {},
  },
  data() {
    return {
      scanTabIndex: 0,
      sortBy: 'signal',
      sortDesc: true,
      scanfields: [
        { key: 'index', label: '#' },
        { key: 'ssid', label: "SSID", sortable: true },
        { key: 'bssid', label: "MAC", sortable: true },
        { key: 'signal', label: "Signal", sortable: true },
        { key: 'channel', label: "Channel", sortable: true },

      ],

    }
  },


  watch: {
    tabIndex(newIndex) {
      localStorage.scanTabIndex = JSON.stringify(scanTabIndex);
    }
  },
  mounted() {
    if (localStorage.scanTabIndex) {
      this.scanTabIndex = parseInt(localStorage.scanTabIndex);
    }
  },
  methods: {
    setName(val) {
      if (val.startsWith("wlan0")) return "2.4 GHz";
      else if (val.startsWith("wlan1")) return "5 GHz";
      else return val;

    },

  }

};
</script>
